import { Button } from "components/DesignSystem/Button/Button";
import { CheckoutModal } from "components/CheckoutModal/CheckoutModal";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { useToast } from "hooks/useToast";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useAddProductsToCartAndCheckoutMutation } from "store/apis/billing";
import { taskAlarmApis } from "store/apis/taskList";
import { BillingInvoice } from "types/Models/billing";
import { TaskDeadlineOverviewItem } from "types/Models/task";
import { BackendError } from "types/utils/error";
import { useUpdateQuery } from "hooks/useQuery";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const LaunchFiling = ({
  item,
  onPayClick,
}: {
  item: TaskDeadlineOverviewItem;
  onPayClick?: () => void;
}) => {
  const [alarmInvoice, setAlarmInvoice] = useState<BillingInvoice | null>();
  const group = useCurrentGroupContext();
  const { alertToast } = useToast();
  const entityId = item.entity.uuid;
  const { uuid: groupId } = group;
  const { update } = useUpdateQuery();
  const { isForeignCA } = useRoleBasedView();

  const alarmInvoiceModal = useModal();
  const dispatch = useDispatch();

  const [createProductInvoice, { isLoading: addingProduct }] =
    useAddProductsToCartAndCheckoutMutation();

  const payInkleToLaunchFiling = async () => {
    onPayClick?.();

    if (
      groupId &&
      item.base_task_template.uuid &&
      item.product_content_type_id
    ) {
      try {
        const payload = {
          entity_id: entityId,
          product_content_type_id: item.product_content_type_id,
          product_id: item.base_task_template.uuid,
          quantity: 1,
          payment_amount:
            !item.payment_amount || isNaN(Number(item.payment_amount))
              ? 0
              : Number(item.payment_amount),
          season: item.season.toString(),
          alarm_id: item.alarm_uuid || undefined,
        };

        const invoiceData = await createProductInvoice({
          groupId: groupId,
          entityId,
          productData: [payload],
          from_alarms: true,
        }).unwrap();

        setAlarmInvoice(invoiceData?.invoice);
        alarmInvoiceModal.open();
      } catch (error) {
        alertToast({ message: (error as BackendError).data?.error?.message });
      }
    }
  };

  const closeAlarmInvoiceModal = () => {
    setAlarmInvoice(null);
    alarmInvoiceModal.close();
  };

  const onPaymentSuccess = () => {
    closeAlarmInvoiceModal();
    dispatch(taskAlarmApis.util.invalidateTags(["TaskList"]));
    update({ query: "check_for_tasks", value: true });
  };

  return (
    <>
      <Button
        onClick={payInkleToLaunchFiling}
        isLoading={addingProduct}
        size="xsmall"
      >
        Pay ${item.payment_amount}
      </Button>

      {alarmInvoiceModal.isOpen && Boolean(alarmInvoice) && (
        <CheckoutModal
          entityId={entityId}
          type="invoices"
          onInvoicePaid={onPaymentSuccess}
          open={alarmInvoiceModal.isOpen}
          onClose={closeAlarmInvoiceModal}
          invoices={[alarmInvoice as BillingInvoice]}
          payerUserType={isForeignCA && "FCA"}
        />
      )}
    </>
  );
};
